// extracted by mini-css-extract-plugin
module.exports = {"navigationControl":"MyMap_navigationControl__3OW6H","geolocateControl":"MyMap_geolocateControl__cY5HJ","loading":"MyMap_loading__30XL-","cluster":"MyMap_cluster__2bsyH"};